import { useContext } from 'react';
import { Grid, Typography } from '@mui/material';
import { orderContext } from '../OrderContext';
import { DetailsPageHeader } from 'components';


let ShippingAddress = () => {
    let service = useContext(orderContext);

    return (
        <DetailsPageHeader sectionName='Shipping address'>
            {service.order.shippingAddress &&
                <Grid container>
                    <Grid item xs={3}>
                        <Typography>Name</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.shippingAddress.firstName} {service.order.shippingAddress.lastName}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Email</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.shippingAddress.email}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Phone number</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.shippingAddress.phoneNumber}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Address line 1</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.shippingAddress.addressLine1}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Address line 2</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.shippingAddress.addressLine2}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>City</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.shippingAddress.city}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>State</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.shippingAddress.stateCode}&nbsp;&middot;&nbsp;{service.order.shippingAddress.state}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Postal code</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.shippingAddress.postalCode}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Country code</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.shippingAddress.countryCode}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>ERP address code</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.shippingAddress.erpAddressCode}</Typography>
                    </Grid>
                </Grid>
            }
        </DetailsPageHeader>
    );
}

export default ShippingAddress;